import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=1a4f1070&scoped=true"
import script from "./CCheckbox.vue?vue&type=script&lang=js"
export * from "./CCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CCheckbox.vue?vue&type=style&index=0&id=1a4f1070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f1070",
  null
  
)

export default component.exports